<template>
  <CareWebview class="bg-surface-brand-hi">
    <div class="mx-auto max-w-full px-24 pt-24 pb-12">
      <div class="h-16">
        <TheLogo decoding="sync" loading="eager" />
      </div>
    </div>

    <Home />
  </CareWebview>
</template>

<script setup lang="ts">
import CareWebview from '~/scopes/care-commons/webview/CareWebview.vue'
import TheLogo from '~/scopes/navigation/components/TheLogo.vue'

import Home from '../components/LegacyHelpCenterHome/LegacyHelpCenterHome.vue'
</script>
